const navigationFunctions = (): void => {
  // Scrolling
  window.addEventListener('scroll', () => {
    const scrollAmount: number = window.pageYOffset | document.body.scrollTop;

    if (scrollAmount > 100) {
      document.body.classList.add('body--scrolled');
    } else {
      document.body.classList.remove('body--scrolled');
    }
  });

  // Drawer Toggle

  const navToggle = document.querySelectorAll<HTMLElement>('.nav__toggle'),
    body = document.querySelector<HTMLElement>('body'),
    hamburger = document.querySelector<HTMLElement>('.nav__toggle--hamburger');

  navToggle.forEach((element) => {
    element.onclick = (): void => {
      body.classList.toggle('nav--visible');
      hamburger.classList.toggle('is-active');
    };
  });

  // Menu Toggle

  const megaMenuToggle = document.querySelectorAll<HTMLElement>(
    '[data-mega-menu-toggle="true"]'
  );

  megaMenuToggle.forEach((toggle) => {
    toggle.onclick = (): void => {
      const megaMenuToggleTarget = toggle.getAttribute('data-mega-menu-target'),
        megaMenuToggleDrawer = document.querySelector(
          '[data-mega-menu-drawer="' + megaMenuToggleTarget + '"]'
        );
      if (megaMenuToggleDrawer) {
        megaMenuToggleDrawer.classList.toggle('menu-item__mega-menu--show');
      }
    };
  });

  // Mega Menu Height
  const megaMenuMatchHeight = (): void => {
    document
      .querySelector('.navbar__menu')
      .setAttribute('style', '--mega-menu-height: auto;');

    // Get elements
    const megaMenus = document.querySelectorAll<HTMLElement>(
      '.menu-item__mega-menu'
    );

    // Find out how my elements there are
    const arrayLength: number = megaMenus.length;
    const heights: number[] = [];

    // Create a loop that iterates through the megaMenus variable and pushes the heights of the elements into an empty array
    for (let i = 0; i < arrayLength; i++) {
      heights.push(megaMenus[i].offsetHeight);
    }

    // Find the largest of the divs
    const getHighest = (): number => {
      return Math.max(...heights);
    };

    // Set a variable equal to the tallest element
    const tallest = getHighest();
    // Iterate through megaMenus and set all their height style equal to the tallest variable
    // for (let i = 0; i < megaMenus.length; i++) {
    // megaMenus[i].style.height = tallest + 'px';
    // }
    document
      .querySelector('.navbar__menu')
      .setAttribute('style', '--mega-menu-height: ' + tallest + 'px;');
  };

  megaMenuMatchHeight();

  const onresize = (): void => {
    megaMenuMatchHeight();
  };
  window.addEventListener('resize', onresize);
};

export default navigationFunctions;
